import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: 'root'
})
export class TestService {

    private url = `http://localhost:5001/api/test`;
    private url2 = `${environment.apiUrl}/test`;

    public loadingAuthSubject$ = new Subject<boolean>();

    // http options to accepet text as response
    HTTPOptions: Object = {

        headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'ApiKey': 'V4liIl0oaOesos&2cOJsojJUBda346rAFCADLOlUwUoooOwOa39ARAaARA30fccakfv35094jt430ngdpnip3',
        }),
        responseType: 'text'
    };

    constructor(private http: HttpClient) {

    }

    public ppFlick(): Observable<string> {
        return this.http.get<string>(`${this.url}/pp`, this.HTTPOptions);
    }

    public sleepApi(): Observable<any> {
        return this.http.get<any>(`${this.url2}/sleep`);
    }

    public yap(): Observable<any> {
        return this.http.get<any>(`${this.url2}/hub/yapper`);
    }
}